/**
 * The way from a hangar screen to the owner panel (Kyle, 2026-10-03: "I have no idea how to work the
 * owner's panel, or even get to it"). `/` is the live hangar screen, so the panel had no link anywhere a
 * person lands.
 *
 * The control stays on screen. The first version appeared only after a pointer moved or a finger tapped,
 * then faded after four seconds, so a TV sitting still showed no way back (Kyle, 2026-10-11). The word
 * "Owner" is the control's name. It is not an explanation of the page.
 */

export function OwnerLink() {
  return (
    <a href="/manage" className="ownerlink">
      <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false">
        <circle cx="12" cy="8" r="3.4" fill="currentColor" />
        <path d="M5.2 19.5c.7-3.5 3.2-5.4 6.8-5.4s6.1 1.9 6.8 5.4" fill="currentColor" />
      </svg>
      Owner
    </a>
  )
}
